/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import eventService from '../services/DomEventServices/domEventServices'
import { store } from '../store/store'

export const countrySelector = new Vue({
	methods: {
		changeCountriesStyleToggler () {
			$('#countyselectleModal')
				.modal('hide')
			$('body')
				.removeClass('modal-open')
			$('.modal-backdrop')
				.remove()
		},
		toggleDropDown (dropDownId) {
			eventService.toggleDropDown(dropDownId)
		},
		saveChosenCountry (dropDownId = 'country-select', index = 0) {
			const selected = store.getters['siteData/getCountriesWithShipping'][index]

			store.dispatch('siteData/setChosenCountryData', selected)
			// this.setChosenCountryData(this.selected);

			if (this.screenWidth > 991) {
				this.toggleDropDown(dropDownId)
			} else {
				this.changeCountriesStyleToggler()
				this.toggleDropDown(dropDownId)
			}
		}
	}
})
